export const APPFORM_SAVE_AND_LEAVE_EVENT = 'appFormSaveAndLeaveEvent';
export const CHECK_IF_UNSAVED_CHANGES_EVENT = 'checkIfUnsavedChangesEvent';
export const DOCUMENTS_BY_IDS_RETRIEVED_EVENT = 'documentsByIdsRetrievedEvent';
